import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import EFSubLayout from "../../EFSubLayout/EFSubLayout";
import {
  AdminMenuTable,
  AdminModule,
  AdminModuleAccess,
  CameraAccess,
  ConsumptionAdminReport,
  ConsumptionReportTable,
  CustomersTables,
  Dashboard,
  EmailTemplate,
  HubsTables,
  InvoiceTable,
  MeterReading,
  MeterReadingReport,
  Msireports,
  OfficesTable,
  Payment,
  Profile,
  RoleTable,
  Settings,
  UsersTable,
  VehicleAdminReport,
  VehiclesReportTable,
  VendorRatesTable,
  VendorsTable,
  VendorWiseInformation
} from "../../ElectricFuelPages";
import Login from "../../ElectricFuelPages/LoginPages/Login";
import { useSiteContext } from "../../contexts/SiteProvider";
import SmartSoftModal from "../../core/loaders/SmartSoftModal";
import TemplateGallery from "../../ElectricFuelPages/SiteSettings/TemplateGallery";
const EFSiteRoute = () => {
  const { isModalOpen, modalOptions, closeModal } = useSiteContext();
  const protected_routes = () => {
    return (
      <>
      
          <Routes>
            <Route path="/" element={<Login />} />
          </Routes>

          <ToastContainer />
       
      </>
    );
  };
  const site_routes = () => {
    return (
      <>
        <EFSubLayout>
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/offices-list" element={<OfficesTable />} />
            <Route path="/hubs-list" element={<HubsTables />} />
            <Route path="/vendors-list" element={<VendorsTable />} />
            <Route path="/vendors-rates-list" element={<VendorRatesTable />} />
            <Route path="/roles-list" element={<RoleTable />} />
            <Route path="/users" element={<UsersTable />} />
            <Route path="/meter-reading" element={<MeterReading />} />
            <Route path="/meter-reading-report" element={<MeterReadingReport />} />
            <Route path="/msi-reports" element={<Msireports />} />
            <Route
              path="/vehicles-report"
              element={<VehiclesReportTable />}
            />
              <Route
              path="/vehicles-admin-report"
              element={<VehicleAdminReport setStage={""} stage={""} />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route
              path="/consumption-report"
              element={<ConsumptionReportTable/>}
            />
                <Route
              path="/consumption-admin-report"
              element={<ConsumptionAdminReport setStage={""} stage={""}/>}
            />
            <Route
              path="/vendor-wish/:id"
              element={<VendorWiseInformation />}
            />
            <Route path="/invoices" element={<InvoiceTable />} />
            <Route path="/customers" element={<CustomersTables />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/cameras" element={<CameraAccess />} /> 
            <Route path="/modual-admin" element={<AdminModule />} /> 
            <Route path="/modual-admin-access" element={<AdminModuleAccess />} /> 
            <Route path="/menu-settings" element={<AdminMenuTable />} />     
            <Route path="/email-template" element={<EmailTemplate />} /> 
            <Route path="/settings" element={<Settings />} /> 
            <Route path="/my-template" element={<TemplateGallery />} /> 
            
          </Routes>

          <ToastContainer />
        </EFSubLayout>
      </>
    );
  };
  return (
    <>
      <Router>
        <Routes>
          <Route path="/*" element={protected_routes()} />
          <Route path="/login" element={<Login />} />
          <Route path="/e-fuel/*" element={site_routes()} />
        </Routes>
        {isModalOpen && (
          <SmartSoftModal
            active={isModalOpen}
            {...modalOptions}
            closeFunction={closeModal}
          />
        )}
      </Router>

      <ToastContainer />
    </>
  );
};

export default EFSiteRoute;
